import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {InternalTradeOrderViewService} from "../../../services/internal/internal-trade-order-view.service";
import {UserInfoStorageService} from "../../../services/auth/user-info-storage.service";
import {WebTradeOrderView} from "../../../model/internal/web-trade-order-view";
import {FieldRequest} from "../../../model/api/field-request";
import {CCRoles} from "../../../model/security/cc-roles-type";
import {TableRequest} from "../../../model/api/table-request";
import {TableFilter} from "../../../model/api/table-filter";
import {CrudTableComponent} from "../../../crystal-elements/crud/crud-table.component";
import {UserViewFormComponent} from "../user-view-form/user-view-form.component";
import {Trade} from "../../../model/clearing/trade";
import {Order} from "../../../model/clearing/order";
import {Account} from "../../../model/clearing/account";
import {ClearingTableConfigService} from "../../../services/clearing/clearing-table-config.service";
import TYPE = FormFieldConfig.TYPE;
import SHOW_OPTION = WebTradeOrderView.SHOW_OPTION;

@Component({
  selector: 'app-user-views',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class UserViewComponent extends CrudBaseComponent<WebTradeOrderView> {

  //fields
  defaultTemplate: string;
  templates: FieldRecord<any>[];
  users: FieldRecord<any>[] = [];
  showOptions: FieldRecord<any>[];
  commonFilterFields: FieldRecord<any>[] = [];
  orderFilterFields: FieldRecord<any>[] = [];
  tradeFilterFields: FieldRecord<any>[] = [];

  @Input()
  records: WebTradeOrderView[] = [];
  selectedUser: any;

  @ViewChild('ccCrudTable')
  public ccCrudTable: CrudTableComponent;

  @ViewChild('crudTable')
  public crudTable: CrudTableComponent;

  constructor(cdref: ChangeDetectorRef,
              private internalTradeOrderViewService: InternalTradeOrderViewService,
              commonFieldService: CommonFieldService,
              private userInfoStorageService: UserInfoStorageService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = internalTradeOrderViewService;
    this.prepareForCreate = this.prepareRecordForCreate;
    this.prepareForEdit = this.prepareRecordForEdit;
    this.prepareForClone = this.prepareRecordForClone;
    this.beforeSave = this.beforeRecordSave;
    internalTradeOrderViewService.clearStorage();
    this.selectedUser = this.userInfoStorageService.getUsernameFromStorage();
    // this.SetRequest();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.reloadRecords();
  }

  private reloadRecords() {
    // this.SetRequest();
    this.loadRecords(this.tableCurrentRequest);
  }

  // private SetRequest() {
  //   if (!this.tableCurrentRequest)
  //     this.tableCurrentRequest = new TableRequest({});
  //   this.tableCurrentRequest.filters.splice(0);
  //   this.tableCurrentRequest.filters.push({
  //     field: 'userName',
  //     matchMode: 'equals',
  //     operator: 'and',
  //     value: this.selectedUser
  //   })
  // }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [];
    this.tableConfig.push({
      width: 30,
      type: 'BUTTON',
      class: value => 'centered',
      icon: value => value.visible ? 'fas fa-toggle-on record-enabled' : 'fas fa-toggle-off record-disabled',
      command: (record: WebTradeOrderView) => {
        this.activate(record);
      },
      mapId: value => '',
    },)
    // if (this.isViewAdmin()) {
    //   this.tableConfig.push({
    //     field: 'userName',
    //     width: 150
    //   },)
    // }
    this.tableConfig.push(...[
      {
        field: 'viewName',
        width: 150
      },
      {
        field: 'template',
        width: 150
      },
      {
        field: 'clearingHouse',
        mapId: value => WebTradeOrderView.getFilterValue(value, 'clearingHouse')
      },
      {
        field: 'exchangeCode',
        mapId: value => WebTradeOrderView.getFilterValue(value, 'exchangeCode')
      },
      {
        field: 'contractCode',
        mapId: value => WebTradeOrderView.getFilterValue(value, 'contractCode'),
        width: 150
      },
    ]);
    this.initFormFields();
  }

  private initFormFields() {
    const formFields = [];
    if (this.isViewAdmin()) {
      formFields.push(
        {
          field: 'userName',
          required: true,
          column: 2,
          type: TYPE.DROPDOWN,
          filter: true,
          options: () => this.users,
        });
    }
    formFields.push(...[
      {
        field: 'viewName',
        required: true,
        column: 2,
        type: TYPE.TEXT,
      },
      {
        field: 'template',
        required: true,
        column: 2,
        type: TYPE.DROPDOWN,
        options: () => this.templates,
        // changed: () => this.refreshFormFieldFilters()
      },
      {
        field: 'visible',
        column: 3,
        type: TYPE.CHECKBOX,
      },
      {
        field: 'showOption',
        column: 3,
        type: TYPE.DROPDOWN,
        options: () => this.showOptions,
      }]);

    const commonFilterField = UserViewFormComponent.getFiltersFormField('commonFilters', this.commonFilterFields,
      () => UserViewFormComponent.addFilter(this.ccCrudTable.ccFormDialog.ccForm, this.formRecord.commonFilters, this.commonFilterFields),
      (record: TableFilter) => UserViewFormComponent.deleteFilter(this.ccCrudTable.ccFormDialog.ccForm, this.formRecord.commonFilters, record));

    const orderFilterField = UserViewFormComponent.getFiltersFormField('orderFilters', this.orderFilterFields,
      () => UserViewFormComponent.addFilter(this.ccCrudTable.ccFormDialog.ccForm, this.formRecord.orderFilters, this.orderFilterFields),
      (record: TableFilter) => UserViewFormComponent.deleteFilter(this.ccCrudTable.ccFormDialog.ccForm, this.formRecord.orderFilters, record));
    orderFilterField['hidden'] = (record: WebTradeOrderView) => record.showOption == SHOW_OPTION.TRADE_ONLY;

    const tradeFilterField = UserViewFormComponent.getFiltersFormField('tradeFilters', this.tradeFilterFields,
      () => UserViewFormComponent.addFilter(this.ccCrudTable.ccFormDialog.ccForm, this.formRecord.tradeFilters, this.tradeFilterFields),
      (record: TableFilter) => UserViewFormComponent.deleteFilter(this.ccCrudTable.ccFormDialog.ccForm, this.formRecord.tradeFilters, record));
    tradeFilterField['hidden'] = (record: WebTradeOrderView) => record.showOption == SHOW_OPTION.ORDER_ONLY;

    this.formConfig = [
      {
        group: '',
        fields: formFields,
      },
      commonFilterField,
      orderFilterField,
      tradeFilterField
    ];
  }

  public refreshFormFieldFilters(): void {
    this.tradeFilterFields.splice(0);
    this.orderFilterFields.splice(0);
    this.commonFilterFields.splice(0);

    let tradeKeys = Object.keys(new Trade());
    tradeKeys.push(...Object.keys(new Account()).map(value => 'account.' + value));
    tradeKeys.sort();
    for (let field of tradeKeys) {
      if (!ClearingTableConfigService.unfilterableSortableColumns.includes(field)) {
        this.tradeFilterFields.push({
          id: field,
          text: field,
          value: field
        });
      }
    }
    let orderKeys = Object.keys(new Order());
    orderKeys.push(...Object.keys(new Account()).map(value => 'account.' + value));
    orderKeys.sort();
    for (let field of orderKeys) {
      if (!ClearingTableConfigService.unfilterableSortableColumns.includes(field)) {
        this.orderFilterFields.push({
          id: field,
          text: field,
          value: field
        });
      }
    }
    this.orderFilterFields.forEach(orderFilterField => {
      const filterField: FieldRecord<any> = this.tradeFilterFields.find(tradeFilterField => orderFilterField.id == tradeFilterField.id);
      if (filterField) {
        this.commonFilterFields.push(filterField);
      }
    });
    this.tradeFilterFields = [...this.tradeFilterFields];
    this.orderFilterFields = [...this.orderFilterFields];
    this.commonFilterFields = [...this.commonFilterFields];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    this.showOptions = [];
    for (let key in SHOW_OPTION) {
      this.showOptions.push(new FieldRecord(key, key.toLowerCase().replace('_', ' ')))
    }

    this.refreshFormFieldFilters();

    (this.crudService as InternalTradeOrderViewService).getDefaultTemplate().subscribe(apiValidation => {
      if (apiValidation.success) {
        this.defaultTemplate = apiValidation.item;
        this.newRecord.template = this.defaultTemplate
        if (this.formRecord && (!this.formRecord.id || this.formRecord.id < 0)) {
          this.formRecord.template = this.defaultTemplate
          // this.refreshFormFieldFilters();
        }
      } else {
        this.errorMessage(apiValidation.message);
      }
      this.settingsFormLoadingProgressValue += 100 / 3;
    });

    (this.crudService as InternalTradeOrderViewService).getTemplates().subscribe(apiValidation => {
      if (apiValidation.success) {
        this.templates = apiValidation.item ? [...this.getFields(apiValidation.item)] : [];
      } else {
        this.errorMessage(apiValidation.message);
      }
      this.settingsFormLoadingProgressValue += 100 / 3;
    });
    if (this.isViewAdmin()) {
      this.commonFieldService.getClearingUsers(FieldRequest.DEFAULT()).subscribe(apiValidation => {
        this.users = this.getFields(apiValidation);
        // this.selectedUser = this.userInfoStorageService.getUsernameFromStorage();
        // this.userChanged();
        this.markForCheck();
        if (this.ccCrudTable)
          this.ccCrudTable.ccFormDialog.reloadFieldValueMap();
        this.settingsFormLoadingProgressValue += 100 / 3;
      });
    } else {
      this.settingsFormLoadingProgressValue += 100 / 3;
    }

    //init new record Object
    this.newRecord = new WebTradeOrderView();
    this.newRecord.userName = this.userInfoStorageService.getUsernameFromStorage();
  }

  private activate(record: WebTradeOrderView) {
    this.formRecord = record;
    if (this.formRecord) {
      this.formRecord.visible = !this.formRecord.visible;
      this.save(false);
    }
  }

  prepareRecordForCreate() {
    if (this.formRecord) {
      // console.log("-------> rowOrderChanged " + JSON.stringify(this.selectedUser));
      this.formRecord.sortOrder = this.records ? Math.max(...this.records.map(o => o.sortOrder)) + 1 : 0;
      // this.formRecord.userName = this.selectedUser;
    }
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.id = undefined;
      this.formRecord.commonFilters.forEach(filter => filter['id']=undefined)
      this.formRecord.orderFilters.forEach(filter => filter['id']=undefined)
      this.formRecord.tradeFilters.forEach(filter => filter['id']=undefined)
      this.formRecord.sortOrder = this.records ? Math.max(...this.records.map(o => o.sortOrder)) + 1 : 0;
    }
  }

  prepareRecordForEdit() {
    setTimeout(() => {
      if (this.ccCrudTable)
        this.ccCrudTable.ccFormDialog.reloadFieldValueMap();
    });
  }

  beforeRecordSave() {
    if (this.formRecord) {
      UserViewFormComponent.prepareFiltersForSave(this.formRecord.commonFilters);
      UserViewFormComponent.prepareFiltersForSave(this.formRecord.orderFilters);
      UserViewFormComponent.prepareFiltersForSave(this.formRecord.tradeFilters);
    }
  }

  rowOrderChanged(records: WebTradeOrderView[]) {
    this.formLoading = true;
    let hasChanged: boolean = false;
    records.forEach((value, index) => {
      if (value.sortOrder != index)
        hasChanged = true;
      value.sortOrder = index
    });
    if (hasChanged) {
      this.internalTradeOrderViewService.saveAll(records).subscribe(apiValidation => {
        if (!apiValidation.success) {
          this.errorMessage(apiValidation.message);
        }
        this.internalTradeOrderViewService.clearStorageViews()
        this.selectedRecords.slice()
        this.selectedRecords = [...this.selectedRecords];
        this.formLoading = false
      })
      if (this.ccCrudTable) {
        this.ccCrudTable.ccTable.reloadTableValueMap();
      }
    }
  }

  protected isViewAdmin(): boolean {
    return this.hasRoles(CCRoles.ROLES_INTERNAL_TRADEORDER_VIEW_ADMIN);
  }

  // onFormRecordChanged() {
  //   this.refreshFormFieldFilters();
  // }

  public saveComplete() {
    this.internalTradeOrderViewService.clearStorageViews()
  }

  onFormVisibilityChange(visible: boolean) {
    setTimeout(() => {
      if (visible)                   {

        if (this.formRecord) {
          UserViewFormComponent.initFilters(this.formRecord.commonFilters);
          UserViewFormComponent.initFilters(this.formRecord.orderFilters);
          UserViewFormComponent.initFilters(this.formRecord.tradeFilters);
          this.refreshFormFieldFilters();
        }
      }
      if (this.ccCrudTable)
        this.ccCrudTable.ccFormDialog.reloadFieldValueMap();
    });
  }

  userChanged($event?: any) {
    // if ($event && $event.value)
    //   this.selectedUser = $event.value
    this.newRecord.userName = this.selectedUser;
    this.tableCurrentRequestChanged();
    this.reloadRecords();
  }

  tableCurrentRequestChanged() {
    if (!this.tableCurrentRequest)
      this.tableCurrentRequest = new TableRequest({});
    let userNameFilter = this.tableCurrentRequest.filters2.find(value => value.field == 'userName');
    if (!userNameFilter) {
      this.tableCurrentRequest.filters2.push({
        field: 'userName',
        matchMode: 'equals',
        operator: 'and',
        value: this.selectedUser
      })
    } else {
      userNameFilter.value = this.selectedUser
    }
  }
}
